let id_view_template = `<strong>ID</strong> 
                        {{#if id}}
                            <input disabled="true" type="text" style="border: none; background: transparent; font-family: monospace; width: 22em; text-align: right;" class="copy-field" value="{{id}}"></input>
                            <span class="copy-button btn btn-text btn-xs fa fa-copy" data-toggle="tooltip" title="Click to copy ID"></span>
                        {{else}}
                            no id?
                        {{/if}}`;

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

let IDView = Marionette.View.extend({
    template: Handlebars.compile(id_view_template),
    className: 'id info',
    ui: {
        copy_field: '.copy-field',
        copy_button: '.copy-button',
        tooltips: '[data-toggle="tooltip"]'
    },
    events: {
        'click@ui.copy_field': 'copy'
    },
    onRender: function() {
        this.ui.tooltips.tooltip();
    },
    copy: function() {
        this.ui.copy_field.attr('disabled', false);
        this.ui.copy_field.select();
        document.execCommand('copy');
        document.getSelection().empty();
        this.ui.copy_field.attr('disabled', true);
        this.ui.copy_button.removeClass('fa-copy');
        this.ui.copy_button.addClass('fa-check');
        this.ui.tooltips.tooltip('hide');
        this.$el.addClass('copied');
        setTimeout(function(){
            this.ui.copy_button.removeClass('fa-check').addClass('fa-copy');
            this.$el.removeClass('copied');
        }.bind(this), 1000);
    }
});

export default IDView;
